import SVGInject from '@iconfu/svg-inject'

export function footerBg() {
	const footerEl = document.querySelector('.footer-wrapper');
	const bodyEl = document.querySelector('body');
	const config = {
		root: null,
		rootMargin: '0px 0px -75% 0px',
	};

	const observer = new IntersectionObserver(handleIntersection, config);
	observer.observe(footerEl);

	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			toggleBg(entry.isIntersecting);
		})
	}

	function toggleBg(intersecting) {
		if (intersecting) {
			footerEl.classList.add('body-bg-transition');
			footerEl.classList.add('use-inverse-theme');
			bodyEl.classList.add('body-bg-transition');
			bodyEl.classList.add('use-inverse-theme');
		} else {
			footerEl.classList.remove('use-inverse-theme');
			bodyEl.classList.remove('use-inverse-theme');
			footerEl.addEventListener('animationend', () => {
				footerEl.classList.remove('body-bg-transition');
				bodyEl.classList.remove('body-bg-transition');
			}, {once: true});
		}
	}
}

export function injectSvg() {
	SVGInject(document.querySelectorAll('img.injectable'), {
		onAllFinish: () => {
			// update fill colours in footer cta icons to use a css variable

			const svgs = Array.from(document.querySelectorAll('.footer-cta svg.injectable'));
			if (svgs.length) {
				svgs.forEach(svg => {
					const filledPaths = svg.querySelectorAll('[fill]');
					if (filledPaths.length) {
						filledPaths.forEach(path => {
							path.setAttribute('fill', 'var(--clr-text)');
						})
					}
				})
			}
		},
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/footer.js